import React from 'react';
import {
  ACTIVITY_ACTION,
  MAINTENANCE_SERVICE_ORDER_PRIORITY,
  PREVENTIVE_TASK_EXECUTION_STATUS,
  PREVENTIVE_TASK_REPEAT_TYPE,
  RESOURCE_EXECUTION_MODE,
} from '../../../../../config/constants';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import EnumStatus from '../../../../common/EnumStatus';
import DateCell from '../../../../common/cells/DateCell';
import { DATE_TIME_FORMAT } from '../../../../../config/locale';
import {
  preventiveTaskExecutionFullInformationPropTypes,
  preventiveTaskExecutionFullInformationDefaultProps,
} from '../proptypes/PreventiveTaskExecutionProptypes';

const getUserLabel = (user, executorUserId) => {
  if (user && user.fullName && user.username) {
    return `${user.fullName} (${user.username})`;
  }

  if (user && user.fullName) {
    return user.fullName;
  }

  if (user && user.username) {
    return user.username;
  }

  return executorUserId || '-';
};

const PreventiveTaskExecutionBasicInformationResource = ({
  preventiveTask,
  scheduleDate,
  startedDate,
  completedDate,
  status,
  resourceExecutionMode,
  executorUserId,
  spentAmount,
  fileUrl,
  user,
  comment,
  observation,
}) => (
  <>
    <ResourceProperty label="Código de la Tarea:">
      {preventiveTask && preventiveTask.companyPreventiveTaskId
        ? preventiveTask.companyPreventiveTaskId
        : '-'}
    </ResourceProperty>

    <ResourceProperty label="Nombre de la Tarea:">
      {preventiveTask && preventiveTask.name ? preventiveTask.name : '-'}
    </ResourceProperty>

    <ResourceProperty label="Tipo de Acción:">
      {preventiveTask && preventiveTask.actionType ? (
        <EnumStatus
          enumObject={ACTIVITY_ACTION}
          enumValue={preventiveTask.actionType}
        />
      ) : (
        '-'
      )}
    </ResourceProperty>

    <ResourceProperty label="Prioridad:">
      {preventiveTask && preventiveTask.priority ? (
        <EnumStatus
          enumObject={MAINTENANCE_SERVICE_ORDER_PRIORITY}
          enumValue={preventiveTask.priority}
        />
      ) : (
        '-'
      )}
    </ResourceProperty>

    <ResourceProperty label="Frecuencia:">
      {preventiveTask && preventiveTask.repeatType ? (
        <EnumStatus
          enumObject={PREVENTIVE_TASK_REPEAT_TYPE}
          enumValue={preventiveTask.repeatType}
        />
      ) : (
        '-'
      )}
    </ResourceProperty>

    <ResourceProperty label="Intervalo:">
      {preventiveTask &&
      preventiveTask.repeatInterval !== null &&
      preventiveTask.repeatInterval !== undefined
        ? preventiveTask.repeatInterval
        : '-'}
    </ResourceProperty>

    <ResourceProperty label="Notificación Programada:">
      {preventiveTask &&
      preventiveTask.deviation !== null &&
      preventiveTask.deviation !== undefined
        ? `${preventiveTask.deviation} día(s)`
        : '-'}
    </ResourceProperty>

    <ResourceProperty label="Fecha Programada:">
      {scheduleDate ? (
        <DateCell value={scheduleDate} format={DATE_TIME_FORMAT} />
      ) : (
        '-'
      )}
    </ResourceProperty>

    <ResourceProperty label="Fecha Inicio:">
      {startedDate ? (
        <DateCell value={startedDate} format={DATE_TIME_FORMAT} />
      ) : (
        '-'
      )}
    </ResourceProperty>

    <ResourceProperty label="Fecha Culminación:">
      {completedDate ? (
        <DateCell value={completedDate} format={DATE_TIME_FORMAT} />
      ) : (
        '-'
      )}
    </ResourceProperty>

    <ResourceProperty label="Estado:">
      <EnumStatus
        enumObject={PREVENTIVE_TASK_EXECUTION_STATUS}
        enumValue={status}
      />
    </ResourceProperty>

    <ResourceProperty label="Monto Gastado:">{spentAmount}</ResourceProperty>
    <ResourceProperty label="Archivo Adjunto:">
      {fileUrl ? (
        <a href={fileUrl} target="_blank" rel="noopener noreferrer">
          Ver archivo adjunto
        </a>
      ) : (
        '—'
      )}
    </ResourceProperty>
    <ResourceProperty label="Modo de Ejecución de Recursos:">
      <EnumStatus
        enumObject={RESOURCE_EXECUTION_MODE}
        enumValue={resourceExecutionMode}
      />
    </ResourceProperty>

    <ResourceProperty label="Usuario Ejecutor:">
      {getUserLabel(user, executorUserId)}
    </ResourceProperty>

    <ResourceProperty label="Comentario:">{comment || '-'}</ResourceProperty>
    <ResourceProperty label="Observación:">
      {observation || '-'}
    </ResourceProperty>
  </>
);

PreventiveTaskExecutionBasicInformationResource.propTypes =
  preventiveTaskExecutionFullInformationPropTypes;

PreventiveTaskExecutionBasicInformationResource.defaultProps =
  preventiveTaskExecutionFullInformationDefaultProps;

export default PreventiveTaskExecutionBasicInformationResource;
